import React, { FC } from 'react';
import { Button } from '../../Button';
import { ButtonGroup } from '../../ButtonGroup';
import { Popup } from '../../Popup';
import PopupStructure from '../../PopupStructure';
import { PopupTitle } from '../../PopupTitle';
import styles from './ClientAreement.module.css';

interface ClientAgreementModalProps {
  onConfirm: () => void;
  onClose: () => void;
}

const ClientAgreementModal: FC<ClientAgreementModalProps> = ({
  onConfirm,
  onClose,
}) => {
  return (
    <Popup isShow={true} onClose={onClose}>
      <PopupStructure
        headerComponent={
          <PopupTitle>
            Добавить канал
          </PopupTitle>
        }
        contentComponent={
          <div className={styles["client-agreement-modal__content"]}>
            <p className={styles["client-agreement-modal__text"]}>
              Подключая свой канал YouTube, вы соглашаетесь с
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className={styles["client-agreement-modal__link"]}
              >
                Политикой конфиденциальности Google
              </a>
              <a
                href="https://www.youtube.com/t/terms"
                target="_blank"
                rel="noopener noreferrer"
                className={styles["client-agreement-modal__link"]}
              >
                Условиями использования YouTube
              </a>
            </p>
          </div>
        }
        footerComponent={
          <ButtonGroup>
            <Button onClick={onClose} kind="secondary">Отмена</Button>
            <Button onClick={onConfirm} kind="primary">Соглашаюсь</Button>
          </ButtonGroup>
        }
      />
    </Popup>
  );
};

export default ClientAgreementModal;
